import { writable } from 'svelte/store';

export const isInput = writable(false);
export const isSend = writable(false);